import React, { useState, useRef,useEffect } from 'react';
import { useFormik } from "formik";
import { otpSubmission } from '../../../Constant/constant';
import { useDispatch,useSelector } from 'react-redux';
import { getUserById } from "../../../../redux/user/action";
import {  useParams } from "react-router-dom";
import Spinner from "../../../Layouts/Spinner";
import swal from "sweetalert";
import axiosInstance from '../../../../redux/api';
import ZatcaOtpSuccess from './ZatcaOtpSuccess';





const OnboardingOTP = () => {
  const [otp, setOtp] = useState(new Array(6).fill(""));
  const inputRefs = useRef([]);
  const dispatch=useDispatch();
  const selectedUser = useSelector(({ user: { userbyid } }) => userbyid);
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [text,setText]=useState("")
  const [otpdata,setOtpData]=useState({});
  console.log(otpdata,"dffdsfsfs")




  const formik = useFormik({
    initialValues: {
      otp: "",
      user_id:selectedUser?.user_id
      

    },
    validationSchema: otpSubmission,
    enableReinitialize: true,
    onSubmit: (values) => {
      handleSubmit(values);
    },
  });

  const handleChange = (element, index) => {
    if (isNaN(element.value)) return;

    const newOtp = [...otp];
    newOtp[index] = element.value;
    setOtp(newOtp);

    if (element.value && index < 5) {
      inputRefs.current[index + 1]?.focus();
    }

    formik.setFieldValue("otp", newOtp.join(""));
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };


  const handleSubmit = async (values) => {
   const data={
    ...values
   }
   setLoading(true);
   try {
     const response = await axiosInstance.post("zatca/submit_csr_to_zatca", data);
     if (response?.data) {
      setText(response?.data?.message)
      setOtpData(response?.data.status)
     }
     else{
       swal({
         text: response?.data?.message,
         icon: "error",
         button: "Close",
         timer: 1500,
       });
     }
 
   } catch (err) {
     console.error(err);
   } finally {
     setLoading(false);
   }
  };

  useEffect(() => {
    if (id) {
      dispatch(getUserById(id));
    }
  }, [id,dispatch]);

  console.log(formik.values,'sdfdfsdsfsdfds')

  return (
    <div>
      {otpdata === true ? (
        <ZatcaOtpSuccess />
      ) : (
        <div className="form-card text-center">
          <form onSubmit={formik.handleSubmit}>
            <div className="otp-subtitle">Step 2</div>
            <h2 className="otp-title">Verify OTP</h2>
            <p className="otp-description">
              Please feel free to enter the OTP code provided by ZATCA
            </p>

            <div className="form-group">
              <label htmlFor="otp">Enter OTP</label>
              <div className="otp-container">
                {otp.map((data, index) => (
                  <input
                    key={index}
                    type="text"
                    className="otp-input"
                    maxLength="1"
                    value={data}
                    onChange={(e) => handleChange(e.target, index)}
                    onKeyDown={(e) => handleKeyDown(e, index)}
                    ref={(el) => (inputRefs.current[index] = el)}
                  />
                ))}
              </div>
              {formik.touched.otp && formik.errors.otp && (
                <div className="error">{formik.errors.otp}</div>
              )}
            </div>

            <div className="col-md-12">
              <button
                style={{ marginLeft: "10px", color: "white" }}
                className="buttons background-button mx-auto d-block"
                disabled={loading}
                type="submit"
              >
                {!loading ? "Start Integration" : <Spinner />}
              </button>
            </div>
            <p style={{ color: "red" }}>{text}</p>

            <div className="or-divider">
              <span>OR</span>
            </div>

            <div className="share-link-container">
              <p>Share link with friends</p>
              <a
                href="https://login.zatca.gov.sa"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://login.zatca.gov.sa
              </a>
            </div>
          </form>
        </div>
      )}
    </div>
  );
};

export default OnboardingOTP;
